import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=f8ecccea&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8ecccea')) {
      api.createRecord('f8ecccea', component.options)
    } else {
      api.reload('f8ecccea', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=f8ecccea&", function () {
      api.rerender('f8ecccea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2jfjZTL3VBS3q/JS/offershelp.vue"
export default component.exports